import { Link } from "react-router-dom";

export const BacktoMyAccount = () => {
  return (
    <div className="col-lg-12">
      <div className="backAccount myAccount-back mt-3">
        <Link to="/myaccount">
          <i className="fa-solid fa-chevron-left" /> Back to Account
        </Link>
      </div>
    </div>
  );
};
